/* InstallableAppPrivacyInformation.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _20 = "._18u0idpf{margin-left:0}";
const _19 = "._otyridpf{margin-bottom:0}";
const _18 = "._2hwxidpf{margin-right:0}";
const _17 = "._19pkidpf{margin-top:0}";
const _16 = "._vwz41kw7{line-height:inherit}";
const _15 = "._1dyz1kw7{letter-spacing:inherit}";
const _14 = "._k48p1nn1{font-weight:400}";
const _13 = "._19bvidpf{padding-left:0}";
const _12 = "._n3tdidpf{padding-bottom:0}";
const _11 = "._u5f3idpf{padding-right:0}";
const _10 = "._ca0qidpf{padding-top:0}";
const _9 = "._wd2doqnp._wd2doqnp:focus-visible{font-size:.75rem}";
const _8 = "._ndlb1nn1._ndlb1nn1:focus-visible{font-weight:400}";
const _7 = "._k1hfoqnp._k1hfoqnp:hover{font-size:.75rem}";
const _6 = "._11do1nn1._11do1nn1:hover{font-weight:400}";
const _5 = "._12r21nn1._12r21nn1{font-weight:400}";
const _4 = "._1i92oqnp._1i92oqnp{font-size:.75rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodySmall, BONTERMS_STANDARD_AGREEMENT_URL, FinePrint, LinkButton, PartnerSpecificTermsModal } from '@atlassian/mpac-primitives';
import { MarketplacePartnerType } from '@atlassian/mpac-types/graphql-gateway-types';
import { ExternalLink } from '@atlassian/mpac-ui';
import { useState } from 'react';
import { TEST_IDS } from './constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._vwz41cby{line-height:1.125rem}";
const _2 = "._1wyboqnp{font-size:.75rem}";
const _ = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const privacyInfoListStyle = null;
export const AnalyticsSubjectIds = {
  termsOfUse: 'termsOfUse',
  privacyPolicy: 'privacyPolicy',
  marketplaceTermsOfUse: 'marketplaceTermsOfUse',
  bontermsStandardAgreement: 'bontermsStandardAgreement',
  partnerSpecificTerms: 'partnerSpecificTerms'
};
const FinePrintStyled = forwardRef((_ref, __cmplr) => {
  let {
      as: C = FinePrint,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz131l _1wyboqnp _vwz41cby", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FinePrintStyled.displayName = 'FinePrintStyled';
}
const LinkButtonStyled = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = LinkButton,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1i92oqnp _12r21nn1 _11do1nn1 _k1hfoqnp _ndlb1nn1 _wd2doqnp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LinkButtonStyled.displayName = 'LinkButtonStyled';
}
const MissingPolicyWarning = _ref3 => {
  let {
    partnerName,
    privacyPolicyUrl,
    eula
  } = _ref3;
  if (privacyPolicyUrl && eula) {
    return null;
  }
  if (privacyPolicyUrl && !eula) {
    return /*#__PURE__*/_jsx(FinePrintStyled, {
      children: "".concat(partnerName, " has not provided any terms of use explaining your rights to use the app or how\n        ").concat(partnerName, " may restrict your use of the app. By installing this app, you acknowledge and\n        agree that ").concat(partnerName, " may restrict or prohibit your use of the app at any time.")
    });
  }
  if (!privacyPolicyUrl && eula) {
    return /*#__PURE__*/_jsx(FinePrintStyled, {
      children: "".concat(partnerName, " has not provided a privacy policy explaining how this app will use your data.\n        By installing this app, you acknowledge and agree this app may have unrestricted use of your\n        data. If you do not agree, you should not install this app.")
    });
  }
  return /*#__PURE__*/_jsx(FinePrintStyled, {
    children: "This vendor has not provided terms of use or a privacy policy explaining how they will use\n      your data. By installing this app, you acknowledge and agree this app may have unrestricted\n      use of your data and/or ".concat(partnerName, " may restrict or prohibit your use of the app at any\n      time. If you do not agree, you should not install this app.")
  });
};

// eslint-disable-next-line max-lines-per-function
const BontermsInfo = _ref4 => {
  let {
    vendorLinks,
    partnerName,
    onExternalLinkClick,
    privacyPolicyUrl
  } = _ref4;
  const [isPartnerSpecificTermsModalOpen, setIsPartnerSpecificTermsModalOpen] = useState(false);
  const openPartnerSpecificTermsModal = () => {
    setIsPartnerSpecificTermsModalOpen(true);
  };
  const closePartnerSpecificTermsModal = () => {
    setIsPartnerSpecificTermsModalOpen(false);
  };
  const {
    bonTermsSupported,
    eula,
    partnerSpecificTerms
  } = vendorLinks || {};
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: bonTermsSupported ? /*#__PURE__*/_jsxs("li", {
        children: ["You agree to the ", /*#__PURE__*/_jsx(ExternalLink, {
          href: BONTERMS_STANDARD_AGREEMENT_URL,
          onClick: () => onExternalLinkClick(AnalyticsSubjectIds.bontermsStandardAgreement),
          "data-testid": AnalyticsSubjectIds.bontermsStandardAgreement,
          children: "Standard Agreement"
        }), partnerSpecificTerms ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [" and ".concat(partnerName, "'s "), /*#__PURE__*/_jsx(LinkButtonStyled, {
            appearance: "link",
            onClick: () => {
              openPartnerSpecificTermsModal();
              onExternalLinkClick(AnalyticsSubjectIds.partnerSpecificTerms);
            },
            children: "Provider-Specific Terms"
          }), "."]
        }) : '.']
      }) : eula && /*#__PURE__*/_jsxs("li", {
        children: ["You agree to ".concat(partnerName, "'s "), /*#__PURE__*/_jsx(ExternalLink, {
          href: eula,
          onClick: () => {
            onExternalLinkClick(AnalyticsSubjectIds.termsOfUse);
          },
          "data-testid": AnalyticsSubjectIds.termsOfUse,
          children: "terms of use."
        })]
      })
    }), /*#__PURE__*/_jsx("li", {
      children: privacyPolicyUrl && /*#__PURE__*/_jsxs(_Fragment, {
        children: ["You agree to ".concat(partnerName, " "), /*#__PURE__*/_jsx(ExternalLink, {
          href: privacyPolicyUrl,
          onClick: () => onExternalLinkClick(AnalyticsSubjectIds.privacyPolicy),
          "data-testid": AnalyticsSubjectIds.privacyPolicy,
          children: "privacy policy."
        })]
      })
    }), /*#__PURE__*/_jsx(PartnerSpecificTermsModal, {
      isOpen: isPartnerSpecificTermsModalOpen,
      onClose: closePartnerSpecificTermsModal,
      partnerSpecificTerms: partnerSpecificTerms
    })]
  });
};
const TermsOfUse = _ref5 => {
  let {
    appName,
    links,
    partnerName,
    onExternalLinkClick,
    privacyPolicyUrl,
    eula,
    vendorLinks
  } = _ref5;
  const {
    enableBontermsSupported
  } = useStatsig();
  const isBonTermsEnabled = enableBontermsSupported();
  const marketplaceTermsOfUse = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("li", {
      children: "You permit Atlassian to share anonymized data with ".concat(appName, ".")
    }), /*#__PURE__*/_jsxs("li", {
      children: ["You agree to Atlassian Marketplace's ", /*#__PURE__*/_jsx(ExternalLink, {
        href: links.marketplaceTermsOfUse.expand({}),
        onClick: () => onExternalLinkClick(AnalyticsSubjectIds.marketplaceTermsOfUse),
        "data-testid": AnalyticsSubjectIds.marketplaceTermsOfUse,
        children: "terms of use."
      })]
    })]
  });
  const partnerTermsOfUse = /*#__PURE__*/_jsxs("li", {
    children: ["You agree to ".concat(partnerName, "'s "), eula && /*#__PURE__*/_jsx(ExternalLink, {
      href: eula,
      onClick: () => {
        onExternalLinkClick(AnalyticsSubjectIds.termsOfUse);
      },
      "data-testid": AnalyticsSubjectIds.termsOfUse,
      children: eula && privacyPolicyUrl ? 'terms of use' : 'terms of use.'
    }), eula && privacyPolicyUrl && /*#__PURE__*/_jsx(_Fragment, {
      children: " and "
    }), privacyPolicyUrl && /*#__PURE__*/_jsx(ExternalLink, {
      href: privacyPolicyUrl,
      onClick: () => onExternalLinkClick(AnalyticsSubjectIds.privacyPolicy),
      "data-testid": AnalyticsSubjectIds.privacyPolicy,
      children: "privacy policy."
    })]
  });
  return /*#__PURE__*/_jsxs(FinePrintStyled, {
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_10, _11, _12, _13, _, _2, _14, _15, _16]
      }), /*#__PURE__*/_jsx(BodySmall, {
        as: "h2",
        className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz131l _1wyboqnp _k48p1nn1 _1dyz1kw7 _vwz41kw7"]),
        children: "By installing this app:"
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_17, _18, _19, _20]
      }), /*#__PURE__*/_jsxs("ul", {
        className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf"]),
        children: [marketplaceTermsOfUse, isBonTermsEnabled ? /*#__PURE__*/_jsx(BontermsInfo, {
          partnerName: partnerName,
          vendorLinks: vendorLinks,
          onExternalLinkClick: onExternalLinkClick,
          privacyPolicyUrl: privacyPolicyUrl
        }) : (eula || privacyPolicyUrl) && partnerTermsOfUse]
      })]
    })]
  });
};
export const InstallableAppPrivacyInformation = _ref6 => {
  let {
    vendorLinks,
    links,
    appName,
    partner,
    privacyPolicyUrl,
    endUserLicenseAgreementUrl,
    appIdentifier,
    appKey,
    buildNumber
  } = _ref6;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    name: partnerName,
    type: partnerType
  } = partner || {};
  const onExternalLinkClick = actionSubjectId => {
    fireAnalyticsEvent({
      actionSubjectId,
      eventType: ButtonClickedEvent,
      objectType: 'app',
      objectId: appIdentifier
    });
  };
  if (partnerType === MarketplacePartnerType.AtlassianInternal) {
    return null;
  }
  if (!partnerName) {
    return /*#__PURE__*/_jsx(FinePrintStyled, {
      "data-testid": TEST_IDS.INSTALLABLE_APP_PRIVACY_INFORMATION,
      children: "This third party vendor has not provided a privacy policy or terms of use. Atlassian's Privacy Policy is not applicable to the use of this app."
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": TEST_IDS.INSTALLABLE_APP_PRIVACY_INFORMATION,
    children: [/*#__PURE__*/_jsx(TermsOfUse, {
      eula: endUserLicenseAgreementUrl,
      privacyPolicyUrl: privacyPolicyUrl,
      partnerName: partnerName,
      appName: appName,
      links: links,
      onExternalLinkClick: onExternalLinkClick,
      appKey: appKey,
      buildNumber: buildNumber,
      vendorLinks: vendorLinks
    }), /*#__PURE__*/_jsx(MissingPolicyWarning, {
      partnerName: partnerName,
      privacyPolicyUrl: privacyPolicyUrl,
      eula: endUserLicenseAgreementUrl
    })]
  });
};